import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons } from '@/utils'

import button from '@/components/button'
import { className } from '@/components/misc/version/utils'

function renderUpdateButton(h) {
  return h(
    button,
    {
      props: {
        icon: icons.refresh,
        color: Colors.primary,
        mode: buttonModes.flat,
        tooltip: this.getTranslate('misc.buttons.update')
      },
      on: {
        click: () => window.location.reload()
      }
    }
  )
}

function renderText(h) {
  return h(
    'div',
    {
      class: `${className}-notification__text`,
      domProps: {
        innerHTML: this.getTranslate(`${className}.notification`, { version: this.newVersion })
      }
    }
  )
}

export default function(h) {
  if (this.hasNewVersion) {
    return h(
      'div',
      {
        class: `${className}-notification`
      },
      [
        renderUpdateButton.call(this, h),
        renderText.call(this, h)
      ]
    )
  }
}
